import { getEnvVar } from './getEnvVar'

export function isDevelopmentEnv() {
  return getEnvVar('ENV') === 'development'
}
